import { render, staticRenderFns } from "./addOrEditAuthen.vue?vue&type=template&id=be0ad0fc&"
import script from "./addOrEditAuthen.vue?vue&type=script&lang=js&"
export * from "./addOrEditAuthen.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditAuthen.vue?vue&type=style&index=0&id=be0ad0fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports